import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Vehicle maintenance links DTO
 */
export class VehicleMaintenanceLinksDto extends BaseTenantLinksDto {
  rentalAgreementId?: number | null;
  vehicleDamageId?: number | null;
  vehicleRoadWorthyCheckId?: number | null;
}
